function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5173\\u95ED\\u573A\\u666F",
  transform: "translate(-32.000000, -149.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u5BFC\\u822A",
  transform: "translate(0.000000, 64.000000)"
}, React.createElement("g", {
  id: "packaging\\u5907\\u4EFD",
  transform: "translate(32.000000, 85.000000)"
}, React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "transparent",
  opacity: 0,
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M8.46264705,1.09528869 L13.8155882,3.40496061 C14.2314068,3.58419852 14.4998244,3.98659134 14.5,4.43098291 L14.5,11.5690171 C14.4998244,12.0134087 14.2314068,12.4158015 13.8155882,12.5950394 L8.46264705,14.9047113 C8.16789691,15.0317629 7.83210309,15.0317629 7.53735295,14.9047113 L2.18441177,12.5950394 C1.76859318,12.4158015 1.50017564,12.0134087 1.5,11.5690171 L1.5,4.43098291 C1.50017564,3.98659134 1.76859318,3.58419852 2.18441177,3.40496061 L7.53735295,1.09528869 C7.83210309,0.968237104 8.16789691,0.968237104 8.46264705,1.09528869 L8.46264705,1.09528869 Z M2.64705882,5.34707425 L2.64705882,11.5690171 L7.42647059,13.6307835 L7.42647059,7.52811947 L2.64705882,5.34707425 Z M13.3529412,5.3986745 L11.816647,6.09976482 L11.816647,8.37391483 L11.8235294,8.37391483 L11.816647,8.37765399 L11.816647,8.39747146 L11.7818529,8.39709755 L10.6764706,9.00957005 L10.6764706,8.39709755 L10.6695882,8.39709755 L10.6695882,6.62324559 L8.57352941,7.57971972 L8.57352941,13.6307835 L13.3529412,11.5690171 L13.3529412,5.3986745 L13.3529412,5.3986745 Z M4.67811765,3.55452654 L3.00991178,4.2743126 L8.05658823,6.57762797 L9.75385294,5.80287643 L4.67811765,3.55452654 L4.67811765,3.55452654 Z M8,2.12168491 L6.08670588,2.94691493 L11.1230588,5.17806474 L13.0482059,4.29936489 L8,2.12168491 Z",
  id: "\\u5F62\\u72B6",
  fill: "#333333"
})))));

var SvgIconGroup = function SvgIconGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconGroup.52c3a01f.svg";
export { ForwardRef as ReactComponent };